
export const initialValues = {
  stateId: undefined,
  districtName: undefined,
  countryId: undefined,
  category: undefined,
  activeStatus: 1,
}